import { Controller } from "@hotwired/stimulus";

const TAB_ACTIVE = [
  "bg-white",
  "text-black",
  "shadow-sm",
  "dark:bg-[#27312b]",
  "dark:text-white"
];

const TAB_INACTIVE = [
  "text-gray-500",
  "hover:text-black",
  "dark:text-gray-400",
  "dark:hover:text-white"
];

export default class extends Controller {
  static targets = ["section", "tab"];

  connect() {
    const activeTab = this.tabTargets.find((tab) => tab.getAttribute("aria-selected") === "true");
    this.activateTab(activeTab?.dataset.pricingPageTabParam || "cloud");
  }

  show(event) {
    event.preventDefault();

    const selectedTab = event.currentTarget.dataset.pricingPageTabParam;
    this.activateTab(selectedTab);
    this.scrollToSection(selectedTab);
  }

  scrollToSection(selectedTab) {
    const section = this.sectionTargets.find(
      (element) => element.dataset.pricingPageSectionParam === selectedTab
    );

    if (!section) {
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  activateTab(selectedTab) {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.pricingPageTabParam === selectedTab;

      tab.classList.remove(...TAB_ACTIVE, ...TAB_INACTIVE);
      tab.classList.add(...(isActive ? TAB_ACTIVE : TAB_INACTIVE));
      tab.setAttribute("aria-selected", isActive.toString());

    });

    this.sectionTargets.forEach((section) => {
      section.classList.toggle("hidden", section.dataset.pricingPageSectionParam !== selectedTab);
    });
  }
}
